<template>
  <CustomSelect
    class="w-100"
    inputId="questionLevelPicker"
    inputLabel="انتخاب سطح سوال"
    v-model="selectedLevel"
    :value="value"
    @input="$emit('input', $event)"
    :customOptions="questionLevelOptions"
  ></CustomSelect>
</template>

<script>
export default {
  props: {
    defaultSelectedLevel: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    if (this.defaultSelectedLevel) {
      this.selectedLevel = this.defaultSelectedLevel;
    }
  },
  data() {
    return {
      selectedLevel: null,
      questionLevelOptions: [
        {
          text: "انتخاب کنید",
          value: null,
        },
        {
          text: "آسان",
          value: 1,
        },
        {
          text: "معمولی",
          value: 2,
        },
        {
          text: "سخت",
          value: 3,
        },
        {
          text: "خیلی سخت",
          value: 4,
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
